module.exports = __webpack_public_path__ + "img/cash-payment.bd36b56e.png";